var TOOLTIP_DELAY = 800;
var MODAL_ANIMATION_DURATION = 200;

export { MODAL_ANIMATION_DURATION, TOOLTIP_DELAY };
